module.exports = __webpack_public_path__ + "img/img-antecipa-01.b9fe3f56.png";